import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import Form from "./Form";

function Sponsored() {
  const handleChipClick = useOutletContext();

  useEffect(() => {
    handleChipClick("sponsored");
  }, [handleChipClick]);

  return <Form />;
}

export default Sponsored;
